//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';
import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { ContentLibrarySortType } from '@apis/content-library/contentLibraryApiModel';
import DropdownSelect from '@components/molecules/dropdown-select/DropdownSelect';
import {
  MediaLibrarySortLabels,
  MediaLibrarySortType,
  MediaLibrarySortTypeOptions,
} from '@media-library/constants/mediaLibraryConstants';
import { MediaLibraryTrackingIds } from '@media-library/constants/mediaLibraryTrackingIds';
import { createHasFeatureSelector } from '@redux/selectors/createHasFeatureSelector';

const items = MediaLibrarySortTypeOptions.map((option) => ({
  label: MediaLibrarySortLabels[option],
  value: option,
}));

const defaultSortType = MediaLibrarySortTypeOptions[0];

interface MediaLibrarySortDropdownProps {
  handleChangeSortType: (newSortType: MediaLibrarySortType) => void;
  sortType: MediaLibrarySortType;
}

export const MediaLibrarySortDropdown = ({
  handleChangeSortType,
  sortType,
}: MediaLibrarySortDropdownProps) => {
  const isMostOnBrandEnabled = useSelector(
    createHasFeatureSelector(FeatureNames.MostOnBrand),
  );

  return (
    <StyledDropdown
      defaultValue={defaultSortType}
      handleSelect={(value) =>
        handleChangeSortType(value as MediaLibrarySortType)
      }
      items={
        isMostOnBrandEnabled
          ? items
          : items.filter(
              ({ value }) => value !== ContentLibrarySortType.VISUAL_SCORE,
            )
      }
      trackingId={MediaLibraryTrackingIds.SORT_TYPE_DROPDOWN}
      value={
        !isMostOnBrandEnabled &&
        sortType === ContentLibrarySortType.VISUAL_SCORE
          ? defaultSortType
          : sortType
      }
    />
  );
};

const StyledDropdown = styled(DropdownSelect)`
  width: 170px;
`;
